import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox';

import './index.scss';

export default function ListItem({ active, children, onClick, withCheckbox }) {
  const checkboxClassName = withCheckbox ? 'ListItem--checkbox' : '';
  const activeClassName = active ? 'ListItem--active' : '';

  return (
    <div className={`ListItem ${checkboxClassName} ${activeClassName}`} onClick={onClick}>
      {children}
      {withCheckbox && <Checkbox checked={active} />}
    </div>
  );
}

ListItem.propTypes = {
  active: PropTypes.bool,
  withCheckbox: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

ListItem.defaultProps = {
  active: false,
  withCheckbox: false,
  children: undefined,
  onClick: () => {},
};
